export default {
  ID() {
    return '_' + Math.random().toString(36).substr(2, 9);
  },

  focusElement(id) {
    if (window.innerWidth > 767) {
      const el = document.getElementById(id);

      setTimeout(function () {
        if (el) {
          el.focus();
        }
      }, 10);
    }
  },

  parseJSONObject(jsonString){
    if (jsonString) {
      try {
        const o = JSON.parse(jsonString);
        if (o && typeof o === "object") {
          return o;
        }
      }
      catch (e) { }
    }

    return null;
  },

  normalizarTelefone(telefone) {
    const numero = String(telefone || '').replace(/\D/g, '');
    const tamanho = numero.length;

    if (tamanho === 10 || tamanho === 11) {
      return '55' + numero;
    }

    return numero;
  },

  verificarServerAlternativo(server_alternativo, login) {
    const isAlternativo = (sessionStorage.getItem('base_server') || "") === server_alternativo;

    if (!isAlternativo && !localStorage.getItem('base_server')) {
      sessionStorage.setItem('base_server', server_alternativo);

      setTimeout(() => {
        window.location.href = window.location.href;
      }, 2000);

      return "Conectando ao servidor alternativo." + (login ? " Faça seu login novamente." : "");

    } else {
      sessionStorage.removeItem('base_server');
      return "No momento este canal está indisponível.\nPor favor verifique se sua conexão está estável."
    }
  }
};
